import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CollabPullDialogModule } from '@portal-core/collab/components/collab-pull-dialog/collab-pull-dialog.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { WorkspacePullChangesBarComponent } from './workspace-pull-changes-bar.component';

@NgModule({
  declarations: [WorkspacePullChangesBarComponent],
  imports: [
    CollabPullDialogModule,
    CommonModule,
    LicenseUserAvatarModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule
  ],
  exports: [
    WorkspacePullChangesBarComponent
  ]
})
export class WorkspacePullChangesBarModule { }
